import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkCodeComponent } from './link-code/link-code.component';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from "@angular/forms";
import {CoreModule} from "../../core/core.module";
import {ModalModule} from 'ngx-bootstrap/modal';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from "@ngx-translate/core";
import {TableModule} from "primeng/table";
import { DragDropDirective } from './link-code/drag-drop.directive';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CoreModule,
    ModalModule.forRoot(),
    NgbModule,
    TranslateModule,
    TableModule
  ],
  declarations: [LinkCodeComponent, DragDropDirective]
})
export class ListCodeModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/list-code.module.ts